/**
 * Custom tab | Recommended | Recently viewed
 *
 * Custom tab: uses product.metafields.my_fields.related_products_title and product.metafields.my_fields.related_products
 * Recommended tab: uses Shopify Section Rendering API
 * Recently viewed: uses local storage
 */
import { init as initProductCard } from "../snippets/product-card";

const SECTION_NAME = "main-product-recommendations";
const CURRENT_PRODUCT_CARD_ID = "#current-product-card";
const RECENTLY_VIEWED_ITEMS_LENGTH = 4;
const RECENTLY_VIEWED_CONTAINER_ID = "#product-recently-viewed";
const RECENTLY_VIEWED_TAB_BUTTON_ID = "#recently-viewed-tab-button";

/** @param {HTMLElement} baseElement */
export function init(baseElement) {
  if (baseElement) {
    /* Get recommended products with section rendering API */
    getRecommendedProducts();

    /* Fade in images in the custom tab */
    const customTab = baseElement.querySelector("#custom-tab");
    if (customTab) {
      const cards = customTab.querySelectorAll(".product-card");
      if (cards) {
        cards.forEach(initProductCard);
      }
    }

    /* Get recently viewed products */
    let localData = JSON.parse(localStorage.getItem("recently_viewed"));
    if (!localData) {
      // @ts-ignore
      localData = localStorage.setItem("recently_viewed", JSON.stringify([]));
    }

    // Find the rendered product_card HTML snippet for the current product,
    // productId and save it inside local storage.
    // It's stored in main-product-recommendations section inside the script tag
    const currentProduct = baseElement.querySelector(CURRENT_PRODUCT_CARD_ID);
    if (!(currentProduct instanceof HTMLElement)) return;
    let productId = currentProduct.dataset.productId;
    if (!(currentProduct instanceof HTMLScriptElement)) return;
    let newItem = {
      productId: productId,
      htmlString: currentProduct.text.replace('h2', 'h4'),
    };

    /* Hide the Recently viewed tab button if there's nothing to show */
    hideRecentlyViewedTabButton(
      baseElement,
      localData,
      RECENTLY_VIEWED_TAB_BUTTON_ID,
      productId
    );

    addRecentlyViewedProduct(localData, newItem);
    if (localData) {
      getRecentlyViewedProducts(baseElement, localData, productId);
    }
  }
}

function getRecommendedProducts() {
  const mainProductRecommendations = document.querySelector(`#${SECTION_NAME}`);

  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(mainProductRecommendations);

    const productRecommendationsSection = document.querySelector(
      "#product-recommendations"
    );
    // @ts-ignore
    const productId = productRecommendationsSection.dataset.productId;

    /**
     * Recommended products section should be separated from the 'main-product' so we fetch less html...
     */
    fetch(
      window.Shopify.routes.root +
        `recommendations/products?product_id=${productId}&limit=4&section_id=${SECTION_NAME}`
    )
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("#product-recommendations");

        if (recommendations && recommendations.children.length == 0) {
          //TODO (rare case when there's no recommendations)
          //console.log("No recommendations available");
          productRecommendationsSection.innerHTML =
            '<div style="min-height: 200px; font-size: 12px; margin-left: 16px;"></div>';
        }
        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
          // Fade in images
          const cards = productRecommendationsSection.querySelectorAll(
            ".product-card"
          );
          if (cards) {
            cards.forEach(initProductCard);
          }
        }
      })
      .catch((e) => {
        console.error(e);
      });
  };

  // Not sure if root margin has any effect on it
  const observer = new IntersectionObserver(handleIntersection, {
    rootMargin: "0px 0px 500px 0px",
  });
  observer.observe(mainProductRecommendations);
}

/**
 *
 * @param {{ productId: string; htmlString: string; }[]} localData
 * @param {{ productId: string; htmlString: string; }} newItem
 * @returns
 */
function addRecentlyViewedProduct(localData, newItem) {
  if (!localData) return;
  if (!(localData instanceof Array)) return;
  if (!localData.find((d) => d.productId == newItem.productId)) {
    localStorage.setItem(
      "recently_viewed",
      JSON.stringify([
        newItem,
        ...localData.slice(0, RECENTLY_VIEWED_ITEMS_LENGTH - 1),
      ])
    );
  }
}
/**
 *
 * @param {HTMLElement} baseElement
 * @param {string} productId
 * @returns
 */
function getRecentlyViewedProducts(baseElement, localData, productId) {
  if (!localData) return;
  let recentlyViewedContainer = baseElement.querySelector(
    RECENTLY_VIEWED_CONTAINER_ID
  );
  if (!(recentlyViewedContainer instanceof HTMLElement)) return;

  // Don't show current product
  let filteredLocalData = localData.filter(
    (item) => item.productId != productId
  );
  // Remove comma between array items
  recentlyViewedContainer.innerHTML = filteredLocalData
    .map((d) => d.htmlString)
    .join("");
}

/**
 * @param {HTMLElement} baseElement
 * @param {string | any[]} localData
 * @param {string} tabId
 * @param {string} productId
 */
function hideRecentlyViewedTabButton(baseElement, localData, tabId, productId) {
  let recentlyViewedTabButton = baseElement.querySelector(tabId);
  if (recentlyViewedTabButton instanceof HTMLElement) {
    if (
      !localData ||
      localData.length == 0 ||
      (localData.length == 1 && localData[0].productId == productId)
    ) {
      recentlyViewedTabButton.style.visibility = "hidden";
    }
  }
}
